module.exports = __webpack_public_path__ + "img/seguidor-solar.d593d364.webp";